// extracted by mini-css-extract-plugin
export default {"Menu":"menu_Menu__qSi1S","open":"menu_open__B1kwz","static":"menu_static__e1FEi"};